import React, { Fragment, useState, useRef } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { Grid, TextField, FormControlLabel, Checkbox, FormLabel, Box, InputAdornment, Tooltip, IconButton } from '@material-ui/core';
import { DATE_FORMAT } from './constants';
import { useStyle } from './style';
import errormesages from './errormessages';
import HelpIcon from '@material-ui/icons/Help';
import { TOOLTIP_TEXT } from './constants';
import MaskedInput from 'react-text-mask';
import moment from 'moment';


//used to mask the textfield in DD/MM/YYYY format
function TextMaskCustom(props) {
	const { inputRef, ...other } = props;
	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null);
			}}
			mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
			placeholder={DATE_FORMAT}
		//guide={false}	
		/>
	);
}

export const EirCustomerDetails = ({ isGuest }) => {
	const { register, errors, control } = useFormContext();
	const classes = useStyle();
	const { validation } = errormesages;
	const [allowEmail, setAllowEmail] = useState(false);
	const [dobError, setDobError] = useState(false);
	const firstNameInputRef = useRef();
	const lastNameInputRef = useRef();
	const mobileNumberInputRef = useRef();
	const birthDateInputRef = useRef();
	const emailAddressInputRef = useRef();

	const isDateValid = (dateOfBirth) => {
		var date = moment(dateOfBirth, DATE_FORMAT, true);
		setDobError(false);
		// if date invalid , in future then set error
		if (!date.isValid()) {
			return false;
		}
		else if (date.isAfter()) {
			return false;
		}
		else {
			// check if 18 yr old
			const dateDiff = moment().diff(date, 'years');
			if (dateDiff < 18) {
				setDobError(true);
				return false;
			}
		}

		return true;
	}

	return (
		<Fragment>
			<Grid container>
				<Grid item sm={6}>
					<h4>Customer details</h4>
				</Grid>
				<Grid item sm={6} className={classes.rightAlign}>
					<Box display={{ xs: 'none', sm: 'block', md: 'block' }} >
						<FormLabel className={classes.formLabelColor}> <span style={{ color: 'red', textAlign: 'center' }} >*</span> Required fields </FormLabel>
					</Box>
				</Grid>
			</Grid>

			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Controller
						as={<TextField inputRef={firstNameInputRef} />}
						control={control}
						fullWidth
						id="firstName"
						name="firstName"
						label="First name"
						variant="outlined"
						size="small"
						error={Boolean(errors.firstName)}
						required
						onFocus={() => {
							firstNameInputRef.current.focus();
						}}
						rules={{
							required: { value: true, message: validation.firstnameRequired },
							minLength: { value: 2, message: validation.nameMinLength },
							maxLength: { value: 100, message: validation.nameMaxLength },
							pattern: { value: /^([^0-9]*)$/, message: validation.firstNamePattern }
						}}
					/>
					<ErrorMessage errors={errors} name="firstName">
						{({ message }) => <p className={classes.errorMessage}>{message}</p>}
					</ErrorMessage>

				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						as={<TextField inputRef={lastNameInputRef} />}
						control={control}
						fullWidth
						id="lastName"
						name="lastName"
						label="Last name"
						variant="outlined"
						size="small"
						required
						error={Boolean(errors.lastName)}
						onFocus={() => {
							lastNameInputRef.current.focus();
						}}
						rules={{
							required: { value: true, message: validation.lastNameRequired },
							minLength: { value: 2, message: validation.nameMinLength },
							maxLength: { value: 100, message: validation.nameMaxLength },
							pattern: { value: /^([^0-9]*)$/, message: validation.lastNamePattern }
						}}

					/>
					<ErrorMessage errors={errors} name="lastName">
						{({ message }) => <p className={classes.errorMessage}>{message}</p>}
					</ErrorMessage>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						as={<TextField inputRef={emailAddressInputRef} />}
						control={control}
						fullWidth
						id="emailAddress"
						name="emailAddress"
						label="Email address"
						variant="outlined"
						size="small"
						required
						error={Boolean(errors.emailAddress)}
						onFocus={() => {
							emailAddressInputRef.current.focus();
						}}
						rules={{
							required: { value: true, message: validation.emailAddressError },
							pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: validation.emailAddressError }
						}}

					/>
					<ErrorMessage errors={errors} name="emailAddress">
						{({ message }) => <p className={classes.errorMessage}>{message}</p>}
					</ErrorMessage>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Controller
						as={<TextField inputRef={mobileNumberInputRef} />}
						control={control}
						fullWidth
						id="mobileNumber"
						name="mobileNumber"
						label="Contact mobile number"
						variant="outlined"
						size="small"
						required
						error={Boolean(errors.mobileNumber)}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<Tooltip title={TOOLTIP_TEXT.CONTACT_MOBILE_NUMBER} size="small" >
										<IconButton color="primary" size="small">
											<HelpIcon />
										</IconButton>
									</Tooltip>
								</InputAdornment>
							),
						}}
						onFocus={() => {
							mobileNumberInputRef.current.focus();
						}}
						rules={{
							required: { value: true, message: validation.mobileNumberRequired },
							pattern: { value: /^08[0-9]{8}$/, message: validation.mobileNumberPattern }
						}}
					/>
					<ErrorMessage errors={errors} name="mobileNumber">
						{({ message }) => <p className={classes.errorMessage}>{message}</p>}
					</ErrorMessage>

				</Grid>
				{!isGuest && (

					<Grid item xs={12} sm={6}>
						<Controller
							as={<TextField inputRef={birthDateInputRef} InputProps={{
								inputComponent: TextMaskCustom,
								endAdornment: (
									<InputAdornment position="end">
										<Tooltip title={TOOLTIP_TEXT.DATE_OF_BIRTH_TOOLTIP} size="small" >
											<IconButton color="primary" size="small">
												<HelpIcon />
											</IconButton>
										</Tooltip>
									</InputAdornment>
								),
							}} />}
							fullWidth
							variant="outlined"
							control={control}
							id="birthDate"
							label="Date of birth"
							name="birthDate"
							size="small"
							error={Boolean(errors.birthDate)}
							required
							onFocus={() => {
								birthDateInputRef.current.focus();
							}}
							rules={{
								required: { value: true, message: validation.birthDateError },
								validate: value => isDateValid(value)
							}}
						/>
						<ErrorMessage errors={errors} name="birthDate">
							{({ message }) => <p className={classes.errorMessage}>{message}</p>}
						</ErrorMessage>
						{errors.birthDate && errors.birthDate.type === 'validate' && !dobError && <span className={classes.errorMessage}>{validation.birthDateError}</span>}
						{dobError && <span className={classes.errorMessage}>{validation.birthDateAgeError}</span>}
					</Grid>

				)}

				<Grid item xs={12}>
					{/* <FormControlLabel
						control={
							<Checkbox
								checked={allowEmail}
								color="primary"
								id="allowEmail"
								inputRef={register}
								name="allowEmail"
								onChange={() => setAllowEmail((previousState) => !previousState)}
							/>
						}
						label="By ticking this box I am happy for eir to email me about my order should I not complete it."
					/> */}
				</Grid>
			</Grid>
		</Fragment >
	);

}
